<div [ngSwitch]="closeSectionType">
  <render-wysiwyg
    *ngSwitchCase="'text'"
    class="button-close"
    [html]="closeSectionText">
  </render-wysiwyg>
  <img
    *ngSwitchCase="'custom'"
    class="button-close"
    alt="Imagen personalizada"
    [src]="closeSectionCustomImage">
  <button
    *ngSwitchDefault
    class="button-close">
    <svg>
      <use href="#close"></use>
    </svg>
  </button>
</div>
